import { useRef } from 'react';
import PropTypes from 'prop-types';
import {
  CSSTransition,
  TransitionGroup,
} from 'react-transition-group';

import KeySkillItem from './KeySkillItem';


// nodeRef is required: React 19 removed findDOMNode used by react-transition-group.
// TransitionGroup injects `in`/`onExited`/... props, they are forwarded as is.
const KeySkillTransition = ({ skillName, onDelete, ...transitionProps }) => {
  const nodeRef = useRef(null);
  return (
    <CSSTransition
      {...transitionProps}
      nodeRef={nodeRef}
      timeout={800}
      classNames="key-skill"
    >
      <KeySkillItem
        ref={nodeRef}
        skillName={skillName}
        onDelete={onDelete}
      />
    </CSSTransition>
  );
};

KeySkillTransition.propTypes = {
  skillName: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const KeySkillItems = ({ onKeySkillDelete, skills = [] }) => (
  <TransitionGroup className="key-skill-container mb-2" component="div">
    {skills && skills.map(({ value }, index) => (
      <KeySkillTransition
        key={String(index)}
        skillName={value}
        onDelete={() => onKeySkillDelete(index)}
      />
    ))}
  </TransitionGroup>
);

KeySkillItems.propTypes = {
  skills: PropTypes.arrayOf(PropTypes.object),
  onKeySkillDelete: PropTypes.func.isRequired,
};

export default KeySkillItems;
